import React, { useEffect, useState } from "react";
import {
  Input,
  Label,
  Dropdown,
  Option,
  Field,
  Card,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import InfoButton from "../../GenericComponent/InfoButton";
import "../../CSS/AnalyticsProfileForm.css";

const AnalyticsProfileForm = (props) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  // Handle input change for nested objects in reportConfig
  const handleNestedChange = (section, field, value) => {
    props.setProfile({
      ...props.profile,
      reportConfig: {
        ...props.profile.reportConfig,
        [section]: {
          ...props.profile.reportConfig?.[section],
          [field]: value,
        },
      },
    });
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};

  
    if (!props.profile?.scope) {
      newErrors.scope = t("THIS_FIELD_IS_REQUIRED");
    }

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    props.setFormValid?.(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [props.profile?.scope]);

  return (
    <div className="analytics-profile-form-root">
     
      {/* Scope */}
      <div className="analytics-profile-form-group">
        <Field
          label={t("SCOPE")}
          className="analytics-profile-form-field"
          required
          validationMessage={errors.scope}
          validationState={errors.scope ? "error" : "none"}
        >
          <Dropdown
          disabled={props.isEditMode}
            placeholder={t("SELECT_SCOPE")}
            value={props.profile?.scope || ""}
            selectedOptions={props.profile?.scope ? [props.profile.scope] : []}
            onOptionSelect={(e, data) =>
              props.setProfile({ ...props.profile, scope: data.optionValue })
            }
          >
            {props.SCOPES_NAMES?.map((scope) => (
              <Option key={scope} value={scope}>
                {scope}
              </Option>
            ))}
          </Dropdown>
        </Field>
      </div>

      {/* Thresholds Section */}
 
        <h3>{t("THRESHOLDS")}</h3>
        
        <div className="analytics-profile-form-group">
          <Field label={t("QUICK_DROP_THRESHOLD")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.thresholds?.quickDropThreshold || 6}
                onChange={(e) =>
                  handleNestedChange("thresholds", "quickDropThreshold", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("QUICK_DROP_THRESHOLD_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("QUICK_ANSWER_THRESHOLD")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.thresholds?.quickAnswerThreshold || 6}
                onChange={(e) =>
                  handleNestedChange("thresholds", "quickAnswerThreshold", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("QUICK_ANSWER_THRESHOLD_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("STANDARD_ANSWER_THRESHOLD")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.thresholds?.standardAnswerThreshold || 12}
                onChange={(e) =>
                  handleNestedChange("thresholds", "standardAnswerThreshold", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("STANDARD_ANSWER_THRESHOLD_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("DELAYED_ANSWER_THRESHOLD")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.thresholds?.delayedAnswerThreshold || 22}
                onChange={(e) =>
                  handleNestedChange("thresholds", "delayedAnswerThreshold", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("DELAYED_ANSWER_THRESHOLD_INFO")} />
            </div>
          </Field>
        </div>


      {/* Abandon Time Section */}
     
        <h3>{t("ABANDON_TIME")}</h3>
        
        <div className="analytics-profile-form-group">
          <Field label={t("MAX_ABANDON_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.abandonTime?.maxAbandonTime || 180}
                onChange={(e) =>
                  handleNestedChange("abandonTime", "maxAbandonTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("MAX_ABANDON_TIME_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("TARGET_ABANDON_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.abandonTime?.targetAbandonTime || 90}
                onChange={(e) =>
                  handleNestedChange("abandonTime", "targetAbandonTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("TARGET_ABANDON_TIME_INFO")} />
            </div>
          </Field>
        </div>
      

      {/* Talking Time Section */}
     
        <h3>{t("TALKING_TIME")}</h3>
        
        <div className="analytics-profile-form-group">
          <Field label={t("MAX_TALKING_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.talkingTime?.maxTalkingTime || 600}
                onChange={(e) =>
                  handleNestedChange("talkingTime", "maxTalkingTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("MAX_TALKING_TIME_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("TARGET_TALKING_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.talkingTime?.targetTalkingTime || 370}
                onChange={(e) =>
                  handleNestedChange("talkingTime", "targetTalkingTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("TARGET_TALKING_TIME_INFO")} />
            </div>
          </Field>
        </div>
   

      {/* Waiting Time Section */}
        <h3>{t("WAITING_TIME")}</h3>
        
        <div className="analytics-profile-form-group">
          <Field label={t("MAX_WAITING_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.waitingTime?.maxWaitingTime || 360}
                onChange={(e) =>
                  handleNestedChange("waitingTime", "maxWaitingTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("MAX_WAITING_TIME_INFO")} />
            </div>
          </Field>
        </div>

        <div className="analytics-profile-form-group">
          <Field label={t("TARGET_WAITING_TIME")}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Input
                type="number"
                value={props.profile?.reportConfig?.waitingTime?.targetWaitingTime || 150}
                onChange={(e) =>
                  handleNestedChange("waitingTime", "targetWaitingTime", parseInt(e.target.value) || 0)
                }
              />
              <InfoButton content={t("TARGET_WAITING_TIME_INFO")} />
            </div>
          </Field>
        </div>
      
    </div>
  );
};

export default AnalyticsProfileForm;
